const DocMenuConfig: object = [
  {
    pages: []
  }
];

export default DocMenuConfig;
